import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    name: 'home',
    path: '/',
    children: [
      {
        name: 'login',
        path: '/login',
        component: () => import('@pages/logIn/LogInScreen.vue'),
        meta: {
          breadcrumb: 'login'
        }
      },
      {
        name: 'check-email',
        path: '/check-email',
        component: () => import('@pages/logIn/CheckEmailScreen.vue'),
        meta: {
          breadcrumb: 'check-email'
        },
        beforeEnter: (_, from, next) => {
          if (['login', 'youandco'].every(routeName => routeName !== from.name)) {
            next({ name: 'login' })
            return
          }

          next()
        }
      },
      {
        name: 'set-password',
        path: '/set-password',
        component: () => import('@pages/logIn/SetNewPasswordScreen.vue'),
        meta: {
          breadcrumb: 'set-password'
        }
      },
      {
        name: 'points',
        path: '/points',
        component: () => import('@pages/points/PointsScreen.vue'),
        meta: {
          breadcrumb: 'points'
        }
      },
      {
        name: 'transactions',
        path: '/transactions',
        component: () => import('@pages/transactions/TransactionsScreen.vue'),
        meta: {
          breadcrumb: 'transactions'
        }
      },
      {
        name: 'finance',
        path: '/finance',
        component: () => import('@pages/finance/FinanceScreen.vue'),
        meta: {
          breadcrumb: 'finance'
        }
      },
      {
        name: 'youandco',
        path: '/youandco',
        component: () => import('@pages/youandco/YouAndCoScreen.vue'),
        meta: {
          breadcrumb: 'youandco'
        }
      }
    ]
  }

  // {
  //   name: 'Not Found',
  //   path: '/:pathMatch(.*)*',
  //   component: () => import('components/pages/NotFoundComponent.vue'),
  //   meta: {
  //     breadcrumb: '404'
  //   }
  // }
]

export default routes
